import { render, staticRenderFns } from "./IndicatorPlugin.vue?vue&type=template&id=584f9506&scoped=true"
import script from "./IndicatorPlugin.vue?vue&type=script&lang=ts"
export * from "./IndicatorPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./IndicatorPlugin.vue?vue&type=style&index=0&id=584f9506&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "584f9506",
  null
  ,true
)

export default component.exports